
import { createContext, useContext, useState, useEffect } from "react";
import authService from "../services/auth.service";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [role, setRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true); 
  const [username, setUsername] = useState(null);


  const login = (user) => {
  setIsLoggedIn(true);
  setRole(user.role);
  setUsername(user.username);
};

  const setUserData = (user) => {
  if (user?.username) setUsername(user.username);
  if (user?.role) setRole(user.role);
  setIsLoggedIn(!!user?.username);
};
  const logout = () => {
    setIsLoggedIn(false);
    setRole(null);

  };

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const user = await authService.checkStatus();

        if (user?.username && user?.role) {
          login(user);
          setUserData(user);
        } else {
          logout(); 
        }
      } catch (error) {
        logout(); 
      }finally
      { 
        setIsLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, role, isLoading, username, login, logout, setUserData }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
